import { connect } from 'react-redux';
import { Environment } from '../../../models/constants/constants';
import { IAppState } from '../../../models/reduxState';
import { addToHistory, disableBackButton } from '../../app/appActions';
import { ArticleIframe } from '../presentationalComponents/articleIframe';

const mapDispatchToProps = {
  addToHistory,
  disableBackButton,
};

const mapStateToProps = (state: IAppState, _ownProps: any) => {
  return {
    isClientApp: state.GlobalState.environment === Environment.nonAgavePane,
  };
};

export const IframeContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ArticleIframe);
